// extracted by mini-css-extract-plugin
export var childPages = "DefaultArticleLayout-module--childPages--h3tfk";
export var component = "DefaultArticleLayout-module--component--dyUb+";
export var header = "DefaultArticleLayout-module--header--Lx8ja";
export var sliderArea = "DefaultArticleLayout-module--sliderArea--4LLIB";